import React from "react";
import { useForm } from "react-final-form";
import { RadioGroupField, SelectField, TextField } from "@syos-music/form";
import {
  MouthpieceDesign,
  MouthpieceDesignSelectField,
  MouthpieceDesignFontSelectField,
  MouthpieceDesignFont,
} from "@syos-music/instruments";
import { Product } from "@syos-music/products";

import { Box, Grid, MenuItem } from "@mui/material";
import SignatureMouthpieceSelectField from "components/signatureMouthpiece/SignatureMouthpieceSelectField";

const OriginalsType = Product.displayModes.originalsMouthpiece.OriginalsType;

export default function SoundShapingDesignField({
  name,
  instrument,
  instrumentType,
}) {
  const form = useForm();
  const designType = form.getFieldState(`${name}.designType`)?.value;
  const designText = form.getFieldState(`${name}.designText`)?.value;
  const designTextFont = form.getFieldState(`${name}.designTextFont`)?.value;

  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        <RadioGroupField name={`${name}.designType`} row>
          <RadioGroupField.Option value="" label="Aucun" />
          <RadioGroupField.Option value="catalog" label="Syos" />
          <RadioGroupField.Option value="text" label="Text" />
          <RadioGroupField.Option value="signature" label="Signature" />
          <RadioGroupField.Option value="originals" label="Originals" />
        </RadioGroupField>
      </Grid>

      {designType === "catalog" && (
        <Grid item xs={12} md={6}>
          <MouthpieceDesignSelectField
            name={`${name}.designCatalog`}
            required
          />
        </Grid>
      )}

      {designType === "text" && (
        <>
          <Grid item xs={12} md={6}>
            <MouthpieceDesignFontSelectField
              name={`${name}.designTextFont`}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            {designTextFont && (
              <Box
                sx={{ p: 1, mt: 2, bgcolor: (t) => t.palette.background.odd }}
              >
                <MouthpieceDesignFont designFont={designTextFont}>
                  {designText ?? " "}
                </MouthpieceDesignFont>
              </Box>
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name={`${name}.designText`}
              label="Design text"
              fullWidth
              required
            />
          </Grid>
        </>
      )}

      {designType === "signature" && (
        <Grid item xs={12} md={6}>
          <SignatureMouthpieceSelectField
            filters={{
              hasDesignId: true,
              instrument: [instrument],
              instrumentType: [instrumentType],
            }}
            name={`${name}.designSignature`}
            label="Signature"
            required
          />
        </Grid>
      )}

      {designType === "originals" && (
        <Grid item xs={12} md={6}>
          <SelectField
            name={`${name}.designOriginals`}
            required
            label="Originals"
          >
            {OriginalsType.originalsTypes.map((originalsType) => (
              <MenuItem key={originalsType} value={originalsType}>
                <OriginalsType originalsType={originalsType} />
              </MenuItem>
            ))}
          </SelectField>
        </Grid>
      )}
    </Grid>
  );
}

SoundShapingDesignField.Summary = function SoundShapingDesignFieldSummary({
  fieldName,
}) {
  const form = useForm();

  const designType = form.getFieldState(`${fieldName}.designType`)?.value;
  const designCatalog = form.getFieldState(`${fieldName}.designCatalog`)?.value;
  const designOriginals = form.getFieldState(
    `${fieldName}.designOriginals`
  )?.value;

  return (
    <div>
      <span>Design</span>
      {!!designType && <span>&nbsp;: </span>}

      {designType === "catalog" && designCatalog && (
        <MouthpieceDesign design={designCatalog} variant="image" />
      )}

      {designType === "text" && <span>Texte</span>}
      {designType === "signature" && <span>Signature</span>}

      {designType === "originals" && (
        <span>
          <OriginalsType originalsType={designOriginals} />
        </span>
      )}
    </div>
  );
};
